import { defineComponent as f, useCssModule as v, computed as g, createBlock as C, openBlock as y, normalizeClass as s, unref as n, withCtx as r, renderSlot as k, createElementVNode as l, withDirectives as S, mergeProps as V, vModelCheckbox as h } from "vue";
import x from "../labelWrapper/CdrLabelWrapper.vue.mjs";
import p from "../../props/size.mjs";
import A from "../../utils/propValidator.mjs";
import B from "../../props/background.mjs";
const z = ["disabled", "true-value", "false-value", "value"], w = "cdr-checkbox", P = /* @__PURE__ */ f({
  name: "CdrCheckbox",
  inheritAttrs: !1,
  customOptions: {},
  __name: "CdrCheckbox",
  props: {
    /**
         * Passes a CSS class to the label for custom styles
         */
    labelClass: String,
    /**
     * Passes a CSS class to the input for custom styles
     */
    inputClass: String,
    /**
     * Passes a CSS class to the slot wrapper for custom styles
     */
    contentClass: String,
    /**
     * Show checkbox in indeterminate state. (NOTE: this is a visual-only state and there is no logic for when to show it)
     */
    indeterminate: {
      type: [Boolean, String],
      default: !1
    },
    /** Disables the checkbox */
    disabled: Boolean,
    /**
     * The value when checked.
     */
    trueValue: {
      type: [String, Number, Boolean, Object, Array, Symbol, Function],
      default: !0
    },
    /**
     * The value when unchecked.
     */
    falseValue: {
      type: [String, Number, Boolean, Object, Array, Symbol, Function],
      default: !1
    },
    /**
     * The value when used in a checkbox group. Replaces `trueValue` and `falseValue`.
     */
    customValue: [String, Number, Boolean, Object, Array, Symbol, Function],
    /**
     * Sets the background color the input is rendered on
     * @values primary, secondary
     */
    background: B,
    /**
     * @demoSelectMultiple false
     * @values small, medium, large
    */
    size: p,
    /**
     * Use `hide-figure` to hide the checkbox, which leaves the text label as the clickable element.
     * Add appropriate custom styles to convey selected and unselected states.
     * @values hide-figure
     */
    modifier: {
      type: String,
      default: "",
      validator: (e) => A(e, ["", "hide-figure"])
    },
    /** @ignore */
    modelValue: {
      type: [String, Number, Boolean, Object, Array, Symbol, Function]
    }
  },
  emits: {
    /**
    * Event emitted by v-model on the <input> element
    * @param modelValue
    */
    "update:modelValue": null
  },
  setup(e, {
    emit: i
  }) {
    const d = e, c = i, m = {
      mounted(t, a) {
        if (a.value) {
          t.setAttribute("indeterminate", a.value);
          return;
        }
        t.removeAttribute("indeterminate");
      },
      updated(t, a) {
        if (a.value) {
          t.setAttribute("indeterminate", a.value);
          return;
        }
        t.removeAttribute("indeterminate");
      }
    }, o = v(), u = g({
      get() {
        return d.modelValue;
      },
      set(t) {
        c("update:modelValue", t);
      }
    });
    return (t, a) => (y(), C(x, {
      class: s(n(o)[w]),
      size: e.size,
      modifier: e.modifier,
      "label-class": e.labelClass,
      "content-class": e.contentClass,
      background: e.background,
      disabled: e.disabled
    }, {
      input: r(() => [S(l("input", V({
        class: [n(o)["cdr-checkbox__input"], e.inputClass],
        disabled: e.disabled,
        type: "checkbox"
      }, t.$attrs, {
        "true-value": e.customValue ? null : e.trueValue,
        "false-value": e.customValue ? null : e.falseValue,
        value: e.customValue,
        "onUpdate:modelValue": a[0] || (a[0] = (b) => u.value = b)
      }), null, 16, z), [[m, e.indeterminate], [h, u.value, void 0, {
        lazy: !0
      }]])]),
      svgs: r(() => [l("div", {
        class: s(n(o)["cdr-checkbox__svg-box"])
      }, [...a[1] || (a[1] = [l("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }, [l("path", {
        role: "presentation",
        d: `M9.673 18.669h.001L19.766 6.644a1 1 0 10-1.532-1.286l-9.3
            11.085-3.169-3.776a1 1 0 10-1.532 1.286l3.875 4.618a.999.999 0 001.565.099z`
      })], -1)])], 2)]),
      default: r(() => [k(t.$slots, "default")]),
      _: 3
    }, 8, ["class", "size", "modifier", "label-class", "content-class", "background", "disabled"]));
  }
});
export {
  P as default
};
